import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from '../../../infra/routing';
import { t } from '../../../infra/i18n';
import { FirstCampaignModal } from './first-campaign-modal';
import { isBarberSessionView, useSession } from '../../../infra/session';
import { useToggle } from '../../../infra/small-tools/use-toggle';
import { getSearchParamValue, hasSearchParam, removeSearchParam } from '../utils/query-string';
import { buildCampaignViewUrl } from '../utils/url-builders';
export var FirstCampaignModalContainer = function () {
    var session = useSession().data;
    var navigate = useNavigate();
    var barberName = session && isBarberSessionView(session.view) ? session.view.viewer.firstName : undefined;
    var firstCampaignModalOpen = useToggle(false);
    useEffect(function () {
        if (hasSearchParam('firstCampaign') && !firstCampaignModalOpen.isOn) {
            firstCampaignModalOpen.setOn();
        }
    }, [firstCampaignModalOpen]);
    var handleCloseModal = function () {
        firstCampaignModalOpen.setOff();
        removeSearchParam('firstCampaign');
    };
    var handleViewCampaign = function () {
        var campaignId = getSearchParamValue('firstCampaign');
        handleCloseModal();
        navigate(buildCampaignViewUrl({ campaignId: campaignId, session: session }));
    };
    var title = barberName
        ? t('engage:first_campaign.modal_title_with_name', { name: barberName })
        : t('engage:first_campaign.modal_title');
    return (_jsx(FirstCampaignModal, { isOpen: firstCampaignModalOpen.isOn, onCloseModal: handleCloseModal, onViewCampaign: handleViewCampaign, title: title }));
};
